import { render, staticRenderFns } from "./ReportsCopy.vue?vue&type=template&id=3ae1840e&"
import script from "./ReportsCopy.vue?vue&type=script&lang=js&"
export * from "./ReportsCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports